











































import Vue from "vue";

export default Vue.extend({
  name: "SubscriptionGuestAnswers",
  props: ["guests"],
  data: () => ({
    paymentOptionsData: [],
  }),
  computed: {
    tableHeaders() {
      return [
        {
          text: "Nom",
          value: "identity",
        },
        {
          text: "Options",
          value: "options",
        },
      ];
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
    close(reset: boolean) {
      this.handleClick();
    },
  },
});
